import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SelectBanco } from 'sharedComponents/select'

const CodigoBancoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='COD BANCO' htmlFor='select-codigoBanco' md={4} />
      <Col md={8}>
        <Field name='codigoBanco'>
          {({ field }) => (
            <SelectBanco {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='select-codigoBanco' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoBancoFormGroup)
